import React from "react";
import siteMetadata from "../siteMetadata";
import ArticleSummary from "./ArticleSummary";
import Bio from "./Bio";
import Pagination from "./Pagination";
import styles from "./BlogIndexPage.module.css";

function BlogIndexPage({ blogRoot, pageCount, pageNumber, postRoutes }) {
  const [featuredPost, ...remainingPosts] = postRoutes;
  const stats = [
    { value: "4x", label: "Faster writing flow" },
    { value: "100+", label: "Languages supported" },
    { value: "Any site", label: "Browser-first workflow" },
  ];

  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <span className={styles.chip}>Voice-to-text tips & updates</span>
          <h1 className={styles.title}>Do not just read about AI writing. Build a faster workflow around it.</h1>
          <p className={styles.subtitle}>{siteMetadata.description}</p>
          <div className={styles.actions}>
            <a href="https://voicetyping.xyz/login" className={styles.primaryAction}>
              Start free
            </a>
            <a href="https://voicetyping.xyz/dashboard/help" className={styles.secondaryAction}>
              Explore guides
            </a>
          </div>
          <Bio />
        </div>

        <aside className={styles.featurePanel}>
          <div className={styles.panelCard}>
            <div className={styles.panelEyebrow}>Featured article</div>
            {featuredPost && (
              <ArticleSummary
                blogRoot={blogRoot}
                route={featuredPost}
                variant="featured"
              />
            )}
          </div>
          <div className={styles.statsCard}>
            {stats.map((item) => (
              <div key={item.label} className={styles.statItem}>
                <strong>{item.value}</strong>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </aside>
      </section>

      <section className={styles.sectionHeading}>
        <div>
          <span className={styles.sectionLabel}>Latest posts</span>
          <h2>Practical guides, product updates, and voice workflow ideas</h2>
        </div>
        <p>
          Learn how to use VoiceTyping across docs, email, support workflows,
          accessibility use cases, and polished browser-first writing flows.
        </p>
      </section>

      <ul className={styles.articlesList}>
        {remainingPosts.map((route) => (
          <li key={route.url.href}>
            <ArticleSummary blogRoot={blogRoot} route={route} />
          </li>
        ))}
      </ul>

      {pageCount > 1 && (
        <Pagination
          blogRoot={blogRoot}
          pageCount={pageCount}
          pageNumber={pageNumber}
        />
      )}
    </div>
  );
}

export default BlogIndexPage;
